import { render } from "./LokalTyp.vue?vue&type=template&id=5598e0e7"
import script from "./LokalTyp.vue?vue&type=script&lang=js"
export * from "./LokalTyp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__